module.exports = __webpack_public_path__ + "static/media/banner1768.7550c2d0.jpg";